import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { AuthContext } from '../contexts/AuthContext';
import MultiFactorModal from '../components/MultiFactorModal';
import {validateUsername, validatePassword, validateEmail, validateAdminPassword} from '../components/RegExs';
import '../styles/App.css';
import { APIBaseLink } from '../components/APIBaseLink';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('patient');
  const [showPassword, setShowPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotMessage, setForgotMessage] = useState('');
  const [loginMessage, setLoginMessage] = useState('');
  const [showMfaModal, setShowMfaModal] = useState(false);
  const [userId, setUserId] = useState(null); //Store user ID for MFA
  const [userEmail, setUserEmail] = useState(null); //Store user Eamil for MFA
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const API_BASE_LINK = APIBaseLink();

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log(`Logging in as ${role} with email: ${email}`);

    const obj = { Email: email, Password: password, role: role };
    const js = JSON.stringify(obj);

    try {

      if (!validateEmail(email) && !validateUsername(email)) {
        setLoginMessage("Email or Username is invalid. Please check your credentials.");
        return;
      }

      if (!validatePassword(password) && !validateAdminPassword(password)) {
        setLoginMessage("Password is invalid. Please check your credentials.");
        return;
      }

      const response = await fetch(API_BASE_LINK + "/user/login", {
        method: 'POST',
        body: js,
        headers: { 'Content-Type': 'application/json' }
      });

      const res = await response.json();

      if (response.ok) {
        if (res.user?.mfaEnabled) {
          console.log("MFA required for user:", res.user._id);
          setUserId(res.user._id);
          setUserEmail(res.user.Email);
          setShowMfaModal(true);
        } else if (res.token) {
          localStorage.setItem('token', res.token);
          const userData = jwtDecode(res.token);
          login(userData);

          navigate(role === 'admin' ? '/admin/dashboard' : '/');
        } else {
          console.error("Token is missing in the server response.");
        }
      } else {
        setLoginMessage(res.message || 'Login failed, please check your credentials.');
      }
    } catch (err) {
      console.log("Error during login:", err);
      // setLoginMessage('An error occurred during login.');
      toast.error("Error During Login.");
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    const obj = { Email: forgotEmail };
    const js = JSON.stringify(obj);

    try {

       if (!validateEmail(forgotEmail)) {
        setForgotMessage("Email is not properly formated.");
        return;
      }

      const response = await fetch(API_BASE_LINK + "/user/forgotPassword", {
        method: 'POST',
        body: js,
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.ok) {
        setForgotMessage('Password reset link has been sent to your email.');
        // Optionally, redirect to login page after showing the message
        // navigate('/login');
      } else {
        const res = await response.json();
        setForgotMessage(res.message || 'Error sending reset link.');
      }
    } catch (err) {
      console.log("Error:", err);
      setForgotMessage('An error occurred while sending the reset link.');
    }
  };

  const handleMfaVerification = (token) => {
    localStorage.setItem('token', token);
    const userData = jwtDecode(token);
    login(userData);
    setShowMfaModal(false);
    navigate(role === 'admin' ? '/admin/dashboard' : '/');
  };

  const handleMfaCancel = () => {
    setUserId(null);
    setUserEmail(null);
    setShowMfaModal(false); 
    localStorage.removeItem('token');
  };

  return (
    <div className="form-page">
      <h1>Login</h1>
      <form onSubmit={handleLogin}>
        <div className="form-group">
          <label>Email / Username</label>
          <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Password:</label>
          <div className="password-input-container">
            <input 
              className="password-input"
              type={showPassword ? 'text' : 'password'} 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
            <img 
              src={showPassword ? '/visible.png' : '/hide.png'} 
              alt="Toggle visibility" 
              onClick={() => setShowPassword(!showPassword)} 
              className="password-toggle-icon"
            />
          </div>
        </div>
        <div className="form-group">
          <label>Role:</label>
          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="admin">Admin</option>
            <option value="patient">Patient</option>
          </select>
        </div>
        <button type="submit">Login</button>
      </form>
      
      {loginMessage && <p>{loginMessage}</p>}

      {/* Forgot Password Section */}
      {!showForgotPassword ? (
         <p>
           <button className="forgot-password-btn" onClick={() => setShowForgotPassword(true)}>Forgot Password?</button>
         </p>
       ) : (
         <form onSubmit={handleForgotPassword}>
           <div className="form-group">
             <label>Enter your email to reset password:</label>
             <input 
               type="email" 
               value={forgotEmail} 
               onChange={(e) => setForgotEmail(e.target.value)} 
               required 
             />
           </div>
           <div className="button-group">
             <button className="send-reset-link-btn" type="submit">Send Reset Link</button>
             <button className="cancel-btn" type="button" onClick={() => {setShowForgotPassword(false);
              setForgotMessage("");
             }}>Cancel</button>
           </div>
         </form>
       )}
       
       {forgotMessage && <p>{forgotMessage}</p>}
 
       <p>New here? <a href="/signup">Sign up!</a></p>

      {showMfaModal && (
        <MultiFactorModal 
          userId={userId} 
          userEmail={userEmail} 
          onVerify={handleMfaVerification} 
          onClose={handleMfaCancel} 
        />
      )}
    </div>
  );
}

export default LoginPage;
